import {
  FETCH_INQUIRY_REQUEST,
  FETCH_INQUIRY_SUCCESS,
  FETCH_INQUIRY_FAILURE,
} from '../actions/mgmtRegisterRequest.js';

const initialState = {
  loading: false,
  data: [],   // Ensure `data` is an empty array initially
  error: '',  // Ensure `error` is an empty string initially
};

const inquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INQUIRY_REQUEST:
      return { ...state, loading: true };

    case FETCH_INQUIRY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };

    case FETCH_INQUIRY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default inquiryReducer;